import type { FC } from "react"
import ModalButton from "@/Components/ModalButton"

export const DISCORD_INVITE_URL = "https://discord.gg/ftvtnxNHAc"

type GameEndModalCTAProps = {
  onGoToLobby: () => void
  /** When given, a "Full Breakdown" button leads the row (final-standings screen). */
  onShowBreakdown?: () => void
}

export const GameEndModalCTA: FC<GameEndModalCTAProps> = ({
  onGoToLobby,
  onShowBreakdown,
}) => {
  return (
    <div className="mt-5 flex flex-wrap justify-center gap-3 w-full max-w-5xl mx-auto px-4">
      {onShowBreakdown && (
        <ModalButton
          color="yellow"
          size="md"
          className="min-w-[10rem]"
          onClick={onShowBreakdown}
          data-testid="game-end.full-breakdown-btn"
        >
          <div className="flex items-center justify-center gap-2">
            <i className="fa-solid fa-chart-simple text-lg"></i>
            <span className="font-poppins font-semibold tracking-wide uppercase">
              Full Breakdown
            </span>
          </div>
        </ModalButton>
      )}

      <ModalButton
        color="blue"
        size="md"
        className="min-w-[10rem]"
        onClick={() =>
          window.open(DISCORD_INVITE_URL, "_blank", "noopener,noreferrer")
        }
      >
        <div className="flex items-center justify-center gap-2">
          <i className="fa-brands fa-discord text-lg"></i>
          <span className="font-poppins font-semibold tracking-wide uppercase">
            Join Discord
          </span>
        </div>
      </ModalButton>

      <ModalButton
        color="red"
        size="md"
        className="min-w-[10rem]"
        onClick={onGoToLobby}
      >
        <div className="flex items-center justify-center gap-2">
          <i className="fa-solid fa-house text-lg"></i>
          <span className="font-poppins font-semibold tracking-wide uppercase">
            Go to Lobby
          </span>
        </div>
      </ModalButton>
    </div>
  )
}
